<template>
  <v-card flat>
    <v-flex xs12 class="px-3">
      <v-data-table hide-actions :items="items" :headers="headers" class>
        <template slot="items" slot-scope="{ item }">
          <tr v-if="hasAccess('all_' + item.name)">
            <td>
              <v-checkbox
                readonly
                hide-details
                color="teal"
                :label="item.title"
                :input-value="hasAccess('all_' + item.name)"
              />
            </td>
            <td>
              <v-checkbox
                readonly
                hide-details
                color="teal"
                :input-value="hasAccess('view_' + item.name)"
              />
            </td>
            <td>
              <v-checkbox
                readonly
                hide-details
                color="teal"
                :input-value="hasAccess('add_' + item.name)"
              />
            </td>
            <td>
              <v-checkbox
                readonly
                hide-details
                color="teal"
                :input-value="hasAccess('edit_' + item.name)"
              />
            </td>
            <td>
              <v-checkbox
                readonly
                hide-details
                color="teal"
                :input-value="hasAccess('delete_' + item.name)"
              />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>

    <v-card-actions
      class="grey lighten-4 py-0 mt-2"
      style="flex-direction: row-reverse"
      v-if="can('delete_roles') || can('edit_roles')"
    >
      <v-btn
        icon
        class="mx-0 px-0"
        @click="$emit('delete')"
        v-if="can('delete_roles')"
      >
        <v-icon color="grey darken-2">mdi-delete-outline</v-icon>
      </v-btn>
      <v-divider vertical />
      <v-btn
        icon
        class="mx-0 px-0"
        @click="$emit('edit')"
        v-if="can('add_roles')"
      >
        <v-icon color="grey darken-2">mdi-pencil-outline</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "ViewRole",
  props: ["permissions"],

  computed: {
    headers: vm => [
      { text: vm.$t("part"), value: "title", sortable: false },
      { text: vm.$t("view"), value: "s", sortable: false },
      { text: vm.$t("add"), value: "c", sortable: false },
      { text: vm.$t("edit"), value: "e", sortable: false },
      { text: vm.$t("delete"), value: "d", sortable: false }
    ],

    items() {
      if (this.permissions.length < 1) {
        return [];
      } else {
        return [
          { title: this.$t("dashboard"), name: "dashboard" },
          { title: this.$t("questions"), name: "questions" },
          { title: this.$t("assessments"), name: "assessments" },
          { title: this.$t("CSOs"), name: "CSOs" },
          { title: this.$t("projects"), name: "projects" },
          { title: this.$t("workshops"), name: "workshops" },
          { title: this.$t("reports"), name: "reports" },
          { title: this.$t("settings"), name: "settings" },
          { title: this.$t("roles"), name: "roles" },
          { title: this.$t("users"), name: "users" }
          // { title: this.$t("backups"), name: "backups" }
        ];
      }
    }
  },
  methods: {
    hasAccess(permission) {
      let array = Object.values(this.permissions);
      return array.some(p => p.name == permission);
    }
  }
};
</script>
